import React, { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import LanguageSwitcher from '../features/translation/LanguageSwitcher';

// import Custom Components
import MainMenu from './partials/main-menu';

//import LoginModal from '../features/modal/login-modal';
import { AuthContext } from '../../context/AuthProvider';

import { isIEBrowser } from '../../utils';

function Header(props) {
    const { t } = useTranslation(); // Use o hook useTranslation para tradução
    const { logo = "assets/images/logo.png" } = props;
    const { user, loggedIn, organizerId, organizerList, userRole } = useContext(AuthContext);

    useEffect(() => {
        console.log("User:", user);
    }, [user, organizerList, userRole, organizerId]);

    const showManageEvents = () => {
        if (userRole) {
            if (userRole === "SADMIN") {
                return true;
            } else if (organizerId) {
                if (userRole === "ADMIN" || userRole === "INSPEC") {
                    return true;
                } else if (organizerList && organizerList.permissions && organizerList.permissions.length > 0) {
                    return true;
                }
                console.log("No permission to manage events", organizerList);
            } else {
                console.log("No permission to manage events", organizerList);
            }
        }
        return false;
    }

    return (
        <header className="header header-6">
            <div className="header-top" style={{ padding: 10 }}>
                <div className="container" >
                    <div className="header-left" >
                        <ul className="top-menu top-link-menu d-none d-md-block">
                            <li>
                                <Link to="#">{t("Header.links")}</Link>

                                {showManageEvents() &&
                                    <ul><li><Link to="/organizer/events"><i className="icon-plus"></i>{t("Header.manageEvents")}</Link></li></ul>
                                }

                            </li>
                        </ul>
                    </div>

                    <div className="header-right">
                        <div className="social-icons social-icons-color">
                            <a href="https://www.facebook.com" className="social-icon social-facebook" title="Facebook" target="_blank" rel="noreferrer"><i className="icon-facebook-f"></i></a>
                            <a href="https://www.instagram.com/groovooapp/" className="social-icon social-instagram" title="Pinterest" target="_blank" rel="noreferrer"><i className="icon-instagram"></i></a>
                        </div>
                        <ul className="top-menu top-link-menu">
                            <li>
                                <Link to="#">{t("Header.links")}</Link>
                                <ul>
                                    {loggedIn ?
                                        (!organizerId &&
                                            <li><Link to="/organizer/become-organizer">
                                                {t("Header.sellTickets")}
                                            </Link>
                                            </li>)
                                        :
                                        <li><Link to="/login?redirect=/pages/init-organizer">
                                            {t("Header.sellTickets")}
                                        </Link>
                                        </li>
                                    }
                                    {
                                        loggedIn ?
                                            <li><Link to={{ pathname: '/shop/dashboard', state: { goto: 1 } }}> <i className="icon-user"></i>{user.name} </Link></li>
                                            :
                                            <li><Link to="/login"><i className="icon-user"></i>{t("Header.login")}</Link></li>
                                    }
                                    {
                                        <li>
                                            <div style={{ display: "flex", gap: "10px" }}>
                                                <LanguageSwitcher />
                                            </div>
                                        </li>
                                    }
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="header-middle sticky-header">
                <div className="container">
                    <div className="col-4 header-bottom">
                        <MainMenu />
                        <button className="mobile-menu-toggler">
                            <span className="sr-only">{t("Header.toggleMobileMenu")}</span>
                            <i className="icon-bars"></i>
                        </button>
                    </div>
                    <div className="col-4" >
                        <Link to={`${process.env.PUBLIC_URL}/`} className="logo">
                            <img src={`${process.env.PUBLIC_URL}/${logo}`} alt="Groovoo Logo" width="82" height="20" />
                        </Link>
                    </div>
                    <div className="col-4" >
                        <div className="header-search header-search-extended header-search-visible d-none d-lg-block">
                            <Link to="/events" className="search-toggle" role="button"><i className="icon-search"></i></Link>
                            <form action="/events" method="get">
                                <div className="header-search-wrapper search-wrapper-wide">
                                    <label htmlFor="q" className="sr-only">{t("Header.searchEvent")}</label>
                                    <button className="btn btn-primary" type="submit"><i className="icon-search"></i></button>
                                    <input type="search" style={isIEBrowser() ? { paddingLeft: '30px' } : {}} className="form-control" name="q" id="q" placeholder={t("Header.searchPlaceholder")} required />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className="header-bottom sticky-header" >
                <div className={ "container" }>
                    <div className="header-left">
                        <div className="header-search header-search-extended header-search-visible d-none d-lg-block">
                            <Link to="/events" className="search-toggle" role="button"><i className="icon-search"></i></Link>
                            <form action="/events" method="get">
                                <div className="header-search-wrapper search-wrapper-wide">
                                    <label htmlFor="q" className="sr-only">Search</label>
                                    <button className="btn btn-primary" type="submit"><i className="icon-search"></i></button>
                                    <input type="search" style={ isIEBrowser() ? { paddingLeft: '30px' } : {} } className="form-control" name="q" id="q" placeholder="Search event ..." required />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>  */}

            {/* <div className="header-bottom sticky-header" >
                <div className={ container }>
                    <div className="header-left">
                        <MainMenu />
                        <button className="mobile-menu-toggler">
                            <span className="sr-only">Toggle mobile menu</span>
                            <i className="icon-bars"></i>
                        </button>
                    </div>

                     <div className="header-right">
                        <i className="la la-lightbulb-o"></i><p>Clearance Up to 30% Off</p>
                    </div>
                </div>
            </div>  */}
        </header>
    )
}

export default Header;
